import { useState } from "react"

import { getSupabaseBrowserClient } from "../clients/browser-client"

export function useSupabase() {
  const [supabase] = useState(() => getSupabaseBrowserClient())

  return supabase
}
